module.exports = __webpack_public_path__ + "static/media/ashok.ee60da18.jpg";